export const PURGE_AUTH = 'logOut';
export const SET_AUTH = 'setAuth';
export const SET_ERROR = 'setError';
export const CHECK_AUTH = 'checkAuth';
export const SET_USER = 'setUser';
//
export const JOBS_SET_STORE = 'jobsSetStore';
export const JOBS_SET_SELECTFIELDOPTIONS = 'jobsSetSelectFieldOptions';
